import { ROLES } from '../../../../../constants';

import teamActiveIcon from '../../assets/icons/blue/team_blue.svg';
import teamIcon from '../../assets/icons/grey/team_grey.svg';
import apiIcon from '../../assets/icons/grey/api_grey.svg';
import apiActiveIcon from '../../assets/icons/blue/api_blue.svg';
import usersIcon from '../../assets/icons/grey/users_grey_icon.svg';
import usersActiveIcon from '../../assets/icons/blue/users_blue_icon.svg';
import projectsActiveIcon from '../../assets/icons/blue/projects_blue.svg';
import projectsIcon from '../../assets/icons/grey/projects_grey.svg';
import caseTemplateActiveIcon from '../../assets/icons/blue/case_template_icon_blue.svg';
import caseTemplateIcon from '../../assets/icons/grey/case_template_icon_grey.svg';
import dashboardIcon from '../../assets/icons/grey/dashboard_grey.svg';
import dashboardActiveIcon from '../../assets/icons/blue/dashboard_blue.svg';

export default [
  {
    name: '',
    items: [
      {
        name: 'dashboard',
        titleKey: 'dashboard',
        icon: dashboardIcon,
        activeIcon: dashboardActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/dashboard',
        roles: '*',
      },
    ],
  },
  {
    name: 'Tickets',
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    items: [
      {
        name: 'template',
        titleKey: 'ticket_templates',
        route: '/tickets/templates',
        icon: caseTemplateIcon,
        activeIcon: caseTemplateActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
      {
        name: 'tickets',
        titleKey: 'tickets',
        route: '/tickets/tickets',
        icon: projectsIcon,
        activeIcon: projectsActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
    ],
  },
  {
    name: 'Administration',
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    items: [
      {
        name: 'api-management',
        titleKey: 'Api Management',
        route: '/api-management',
        icon: apiIcon,
        activeIcon: apiActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
      {
        name: 'teams',
        titleKey: 'teams',
        icon: teamIcon,
        activeIcon: teamActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/teams',
        roles: '*',
      },
      {
        name: 'users',
        titleKey: 'users',
        route: '/users',
        icon: usersIcon,
        activeIcon: usersActiveIcon,
        isActive: false,
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
    ],
  },
];
